import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';

/** 系統設定 hub 導覽卡。使用者存取需同時具備帳號與職務讀取。 */
const systemSettingNavigate = [
  {
    to: ROUTES.systemUsers,
    title: '帳號管理',
    subtitle: '查詢與管理系統帳號',
    permission: PERM.SYS_ACCOUNT_READ,
  },
  {
    to: ROUTES.systemRoles,
    title: '職務管理',
    subtitle: '查詢與管理職務角色',
    permission: PERM.SYS_ROLE_READ,
  },
  {
    to: ROUTES.systemUserAccess,
    title: '使用者存取',
    subtitle: '設定帳號可使用的職務',
    permissionAll: [PERM.SYS_ACCOUNT_READ, PERM.SYS_ROLE_READ],
  },
];

export default systemSettingNavigate;
